import { normalizePlate } from "@/utils/normalizePlate";
import {calculateDistancePriority , isVehicleSuitableForOrderDetail , isWashStatus} from "@/utils/recomendation/index.js";
import {calculateCustomerPriority} from "@/utils/recomendation/calculator/calculateCustomerPriority";
import { calculator } from "@/utils/cost";
import { isSequential } from "@/utils/recomendation";
import { checkCargoCompatibility } from "@/utils/recomendation/controller/checkCargoCompatibility";
// Bir sipariş için belirli bir aracı manuel olarak değiştiren fonksiyon
    /**
     * Belirli bir araçla manuel planlama yapar
     * @param {String} plate - Araç plakası
     * @param {Object} item - Sipariş
     * @param {Array} vehicleList - Araç Listesi
     * @param {Array} customers - Müşteriler
     * @param {Array} products - Ürünler
     * @param {String} userToken - Kullanıcı tokeni
     * @param {Boolean} isManualTyped - Kullanıcı elle yazarak mı seçti
*/
export async function changeVehicle(plate , item , vehicleList , customers , products , userToken, isManualTyped = false) {
    
    let vehicle = vehicleList.find(
        (vehicle) =>
            normalizePlate(vehicle.plate) == normalizePlate(plate)
    );

    const isRent = vehicle.haveType ? vehicle.haveType : vehicle.isRent;
    const distancePriority = calculateDistancePriority(item, vehicle);
    const distance = parseFloat(distancePriority).toFixed(2);

    // Vehicle with Wash Status
    const isVehicleSequel =
        vehicle.orderNos.length > 0
            ? isSequential(vehicle, {
                ...item,
                startLat: item.outpointLat,
                startLng: item.outpointLng,
                endLat: item.targetPointLat,
                endLng: item.targetPointLng,
            })
            : false;

    const vehicleWashStatus = isWashStatus(
        customers,
        products,
        { ...vehicle, isSequentialTrue: isVehicleSequel },
        item
    ).status;

    vehicle = {
        ...vehicle,
        recomendation: {
            isWashing: vehicleWashStatus,
        },
    };

    const cost = await calculator(
        userToken,
        1,
        1,
        { ...vehicle, isSequentialTrue: isVehicleSequel },
        item,
        distance,
        0,
        true,
        true,
        1,
        distance / 50
    );

    if (item.vehicle.name != vehicle.vehicle) {
        const oldVehicleIndex = vehicleList.findIndex(
            (vehicle) => vehicle.plate == item.vehicle.name
        );

        vehicleList[oldVehicleIndex].orderNos = vehicleList[
            oldVehicleIndex
        ].orderNos.filter((orderNo) => orderNo !== item.orderNo);

        // Müşteri yük uyumluluğu kontrolü
        const vehicleLastProduct = isVehicleSequel ? vehicle.productId : vehicle.lastProduct;
        const cargoCompatibility = checkCargoCompatibility(
            vehicleLastProduct,
            customers,
            item.customer
        );

        item.vehicle = {
            id: vehicle.id,
            name: vehicle.vehicle,
            position: {
                lat: vehicle.latitude,
                lng: vehicle.longitude,
            },
        };
        item.isRent = isRent;
        //item.haveType = isRent;

        // Manuel/Otomatik atama kontrolü:
        // 1. Kullanıcı elle yazarak arama yaptıysa = her zaman manuel (isCustom: 1)
        // 2. Dropdown'dan direkt seçildiyse:
        //    - Orijinal öneri ile aynı araç = otomatik (isCustom: 2)
        //    - Farklı araç = manuel (isCustom: 1)
        if (isManualTyped) {
            item.isCustom = 1; // Elle yazıldı = manuel atama
        } else {
            const isOriginalRecommendation = item.originalRecommendedVehicleId === vehicle.id;
            item.isCustom = isOriginalRecommendation ? 2 : 1;
        }
        item.vehicleName = vehicle.vehicle;
        item.orderAmount = item.tonnage;
        item.washPointName = cost.washPointName;
        item.recomendationTotalCost = Number(cost.total);
        item.washCost = Number(cost.totalWashPriceCost);
        item.allCost = Number(cost.total) + Number(cost.totalWashPriceCost);
        item.recomendation = {
            rankInPolygon: vehicle?.rankInPolygon,
            isSequentialTrue: isVehicleSequel,
            polygonName: vehicle.polygonName,
            polygonScore: vehicle.polygonScore,
            vehicleInspectionEndDate: vehicle.vehicleInspectionEndDate,
            inspectionEndDate: vehicle.inspectionEndDate,
            vehicleAdrEndDate: vehicle.vehicleAdrEndDate,
            dorseAdrEndDate: vehicle.dorseAdrEndDate,
            srcEndTime: vehicle.srcEndTime,
            name: vehicle.vehicle,
            position: {
                lat: vehicle.latitude,
                lng: vehicle.longitude,
            },
            customerPriority: calculateCustomerPriority(item, customers),
            distancePriority: distance,
            ...isVehicleSuitableForOrderDetail(
                item,
                vehicle,
                products,
                false,
                false
            ),
            isVehicleAvailable:true,
            capacity: (vehicle.capacity / 1000).toFixed(2),
            isWashing: vehicleWashStatus,
            // Yük uyumluluk bilgileri
            isIncompatible: !cargoCompatibility.isCompatible,
            incompatibilityReason: cargoCompatibility.reason,
            rejectedProduct: cargoCompatibility.rejectedProduct,
        };
    }
}